import { atom } from 'recoil';

export const userState = atom({
	key: 'userState',
	default: {
		username: 'Anonimni uporabnik',
		name: null,
		surname: null,
		isLogged: false,
		token: null,
	},
});
